var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExams({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1538 19.2024C25.5454 19.2024 26.88 19.7552 27.864 20.7392C28.848 21.7232 29.4008 23.0578 29.4008 24.4494C29.4008 25.841 28.848 27.1756 27.864 28.1595C26.88 29.1435 25.5454 29.6964 24.1538 29.6964",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5083 30.6292V28.4146",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3705 23.7454V25.3037H20.6223V23.7051",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6223 13.871V11H23.3705V13.9113",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 21.2191V23.7876H19.6797V14.1479H24.3125V17.2536",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8052 28.4146H17.7166",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.237 30.8237H15.8308C15.7386 30.8233 15.6472 30.8409 15.5618 30.8758C15.4765 30.9106 15.3988 30.9619 15.3332 31.0268C15.2677 31.0917 15.2156 31.1688 15.1798 31.2538C15.1441 31.3388 15.1255 31.43 15.125 31.5222V32.9999H28.9446V31.5222C28.9432 31.3358 28.8678 31.1576 28.7352 31.0267C28.6025 30.8957 28.4233 30.8228 28.237 30.8237Z",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0773 19.25C26.0791 19.6307 25.9678 20.0034 25.7576 20.3209C25.5474 20.6384 25.2477 20.8863 24.8964 21.0333C24.5452 21.1802 24.1582 21.2196 23.7846 21.1464C23.4109 21.0733 23.0674 20.8908 22.7975 20.6223C22.5276 20.3537 22.3435 20.011 22.2686 19.6377C22.1936 19.2644 22.2312 18.8772 22.3765 18.5253C22.5218 18.1734 22.7682 17.8725 23.0847 17.6607C23.4012 17.449 23.7733 17.336 24.1541 17.336C24.4063 17.3345 24.6563 17.383 24.8897 17.4785C25.123 17.5741 25.3352 17.7149 25.514 17.8928C25.6927 18.0707 25.8345 18.2822 25.9312 18.5151C26.0279 18.748 26.0775 18.9978 26.0773 19.25V19.25Z",
    stroke: "#572580",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExams);
export default __webpack_public_path__ + "static/media/icon-exams.d3f032abc298da808ec3c7243b7b4aee.svg";
export { ForwardRef as ReactComponent };